/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {NgModule} from '@angular/core';

import { HttpClientModule as NgHttpClientModule, HttpClient } from '@angular/common/http';
import { Router, RouterModule, UrlSerializer } from '@angular/router';

import { CorrectedHttpUrlEncodingCodec, HttpParameterCodecExtended } from './http-parameter-codec-extended';
import { CorrectedHttpParamsBuilder } from './corrected-http-params-builder';
import { CorrectedUrlSerializer, correctRouterParamsSerializer } from './corrected-url-serializer';
import { CorrectedHttpClient, HttpParamsBuilder } from './corrected-http-client';
import { useCorrectedDateJSONSerializer } from './corrected-json-date-serializer';


/**
 * `NgModule` which provides the `HttpClient` and associated services.
 *
 * Interceptors can be added to the chain behind `HttpClient` by binding them
 * to the multiprovider for `HTTP_INTERCEPTORS`.
 *
 * @stable
 */
@NgModule({
  imports: [
    NgHttpClientModule,
    RouterModule
  ],
  providers: [
    { provide: HttpClient, useClass: CorrectedHttpClient },
    { provide: HttpParamsBuilder, useClass: CorrectedHttpParamsBuilder },
    { provide: HttpParameterCodecExtended, useClass: CorrectedHttpUrlEncodingCodec },
    { provide: UrlSerializer, useClass: CorrectedUrlSerializer },
   ],
})
export class CorrectedHttpClientModule {
  constructor(router: Router, encoder: HttpParameterCodecExtended) {
    correctRouterParamsSerializer(router, encoder);
    useCorrectedDateJSONSerializer();
  }
}

/**
 * `NgModule` which provides the `HttpClient` and associated services.
 *
 * Interceptors can be added to the chain behind `HttpClient` by binding them
 * to the multiprovider for `HTTP_INTERCEPTORS`.
 *
 * @stable
 */
@NgModule({
  imports: [
    RouterModule
  ],
  providers: [
    { provide: HttpParameterCodecExtended, useClass: CorrectedHttpUrlEncodingCodec },
    { provide: UrlSerializer, useClass: CorrectedUrlSerializer },
  ],
})
export class CorrectedHttpChildModule {
  //constructor(router: Router, encoder: HttpParameterCodecExtended) {
  //  CorrectRouterParamsSerializer(router, encoder);
  //}
}
